import React from "react";
import Text from "@amzn/meridian/text";
import PropTypes from "prop-types";
import Link from "@amzn/meridian/link";

function TaskCountBox({title, count, onClick}){
  return (
    <div key={title}>
      <Text alignment="left" type="h100">
        {title}
      </Text>
      {
        !onClick ?
          (
            <Text alignment="left" type="d50">
              {count}
            </Text>
          )
          :
          (
            <Text alignment="left" type="d50">
              <Link type="secondary" onClick={onClick}>
                {count}
              </Link>
            </Text>
          )
      }
    </div>
  );
}


TaskCountBox.propTypes = {
  title: PropTypes.element.isRequired,
  count: PropTypes.arrayOf(PropTypes.number).isRequired,
  onClick: PropTypes.func
};


export default TaskCountBox;



// WEBPACK FOOTER //
// ./src/components/overview/TaskCounts/TaskCountBox.jsx